if (!customElements.get('size-guide-man')) {
  class SizeGuideMan extends window.SizeGuideBase {
    get storageKey () { return 'man'; }
    get guideType () { return 'man'; }

    updateFormData (element) {
        const field = element?.dataset?.field;
        const value = element?.value;
        this.formData[field] = value;

        if (this.formData.height !== undefined && this.formData.weight !== undefined && this.formData.age !== undefined) {
            this.computeManRecommendation();
        }
    }

    computeManRecommendation () {
        this.formData.recommendation = this.data.find(
            entry =>
                Number(entry.height) === Number(this.formData.height) &&
                Number(entry.weight) === Number(this.formData.weight) &&
                Number(entry.age) === Number(this.formData.age)
        );

        this._handleRecommendation(this.formData.recommendation?.size);
    }
  }

  customElements.define('size-guide-man', SizeGuideMan);
}
